import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbsenteeismTotalizerQueryInput } from "../../core/interfaces/absenteeism-filter-input";

@Injectable()
export class SStatsCardAbsenteeismService {

    private readonly endpointQuery = "hcm/analytics_payroll/queries";

    constructor(private readonly httpClient: HttpClient) {}

    public getAbsenteeismTotalizerQuery(filter: AbsenteeismTotalizerQueryInput) {
        return this.httpClient.post(`${this.endpointQuery}/absenteeismTotalizerQuery`, {
            ...filter
        });
    }
}
